import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=8d049daa&scoped=true"
import script from "./ActionItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionItems.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=8d049daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d049daa",
  null
  
)

export default component.exports